import { PAGINATION } from 'constants/pagination';

export const USER_MANAGEMENT_PAGE_SIZE = PAGINATION.PAGE_SIZE;

export const USER_MANAGEMENT_LAST_LOGIN_FILTER_VALUES = {
  HAS_LOGGED_IN: 10,
  NEVER_LOGGED_IN: 20,
} as const;

export const USER_MANAGEMENT_LAST_INVITATION_FILTER_VALUES = {
  HAS_INVITATION: 10,
  NEVER_SENT_INVITATION: 20,
} as const;

export const USER_MANAGEMENT_LAST_LOGIN_FILTER_OPTIONS = [
  {
    label: 'Has Logged In',
    value: USER_MANAGEMENT_LAST_LOGIN_FILTER_VALUES.HAS_LOGGED_IN,
  },
  {
    label: 'Never Logged In',
    value: USER_MANAGEMENT_LAST_LOGIN_FILTER_VALUES.NEVER_LOGGED_IN,
  },
];

export const USER_MANAGEMENT_LAST_INVITATION_FILTER_OPTIONS = [
  {
    label: 'Has Invitation',
    value: USER_MANAGEMENT_LAST_INVITATION_FILTER_VALUES.HAS_INVITATION,
  },
  {
    label: 'Never Sent Invitation',
    value: USER_MANAGEMENT_LAST_INVITATION_FILTER_VALUES.NEVER_SENT_INVITATION,
  },
];

export const USER_MANAGEMENT_FEATURE_FLAGS_MODAL_TITLE = 'Set Feature Flags';
export const USER_MANAGEMENT_FEATURE_FLAGS_BULK_SELECTED_SUFFIX = 'selected';
export const USER_MANAGEMENT_FEATURE_FLAGS_USER_UNIT = 'user';
export const USER_MANAGEMENT_FEATURE_FLAGS_BULK_HELP_TEXT =
  "Each row shows how many of the selected users have the flag. **On enables it for all of them, Off disables it for all of them, including users who already had it.** Leave both unselected to keep each user's current setting.";
